import { BVConfigPlugin } from 'bootstrap-vue'
import Vue from 'vue'

Vue.use(BVConfigPlugin, {
  BTable: {
    showEmpty: true,
    emptyText: 'Aucun élément'
  }
})
